var _defs, _rect, _g, _g2, _g3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHetaRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #2172b9;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -0.2,
    y: 0.13,
    width: 180,
    height: 180,
    rx: 90,
    ry: 90
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.33,124.61l-40.48,22.87c-1.29,.73-2.87,.73-4.16,0l-40.36-22.6c-1.36-.76-2.22-2.17-2.27-3.73l-2.7-82.2h94.43l-2.71,82.77c-.04,1.21-.71,2.31-1.76,2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.77,150.1c-1.07,0-2.14-.27-3.09-.8l-40.36-22.6c-1.98-1.11-3.26-3.21-3.33-5.48l-2.76-84.36h98.73l-2.78,84.92c-.06,1.92-1.14,3.7-2.81,4.65l-40.48,22.87c-.96,.54-2.04,.81-3.11,.81ZM44.53,41.03l2.62,80.05c.03,.82,.49,1.58,1.21,1.98l40.36,22.6c.65,.37,1.47,.37,2.12,0l40.48-22.87c.42-.24,.68-.67,.7-1.16l2.64-80.61H44.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.66,84.8c-.77-.77-.77-2.02,0-2.79l20.17-13.82c.77-.77,2.02-.77,2.79,0l20.17,13.82c.77,.77,.77,2.02,0,2.79h-43.13Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 60.58,
    y: 60.8,
    width: 32.47,
    height: 57.52,
    rx: 2.03,
    ry: 2.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 88.11,
    y: 79.15,
    width: 32.47,
    height: 39.17,
    rx: 1.68,
    ry: 1.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.25,65.13c-.77-.77-.77-2.02,0-2.79l20.17-13.82c.77-.77,2.02-.77,2.79,0l20.17,13.82c.77,.77,.77,2.02,0,2.79H55.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.23,
    y: 66.09,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.41,
    y: 66.09,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.23,
    y: 66.09,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.23,
    y: 76.33,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.41,
    y: 76.33,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.23,
    y: 76.33,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.23,
    y: 86.56,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.41,
    y: 86.56,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.23,
    y: 86.56,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 84.23,
    y: 96.79,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 66.23,
    y: 96.79,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.41,
    y: 96.79,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 73.29,
    y: 107.32,
    width: 8.12,
    height: 11.81,
    rx: 0.61,
    ry: 0.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.4,
    y: 86.56,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.23,
    y: 86.56,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.4,
    y: 86.56,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.4,
    y: 97.5,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.23,
    y: 97.5,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.4,
    y: 97.5,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 93.4,
    y: 107.38,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 102.23,
    y: 107.38,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 111.4,
    y: 107.38,
    width: 3.88,
    height: 5.29,
    rx: 0.28,
    ry: 0.28
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "135.67 44.11 133.75 44.05 133.81 42.17 131.93 42.17 131.93 40.25 135.79 40.25 135.67 44.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.96,65.66l-1.91-.06,.18-5.51,1.91,.06-.18,5.51Zm.35-10.77l-1.91-.06,.18-5.51,1.91,.06-.18,5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.76,146.71c-.78,0-1.56-.18-2.25-.53l-.86-.43,.86-1.71,.86,.43c.81,.41,1.82,.43,2.66,.06l.88-.39,.78,1.75-.88,.39c-.65,.29-1.33,.43-2.04,.43Zm7.56-3.52l-.94-1.67,4.8-2.71,.94,1.67-4.8,2.71Zm-15.29-.07l-4.81-2.69,.94-1.67,4.81,2.69-.94,1.67Zm24.67-5.23l-.94-1.67,4.8-2.71,.94,1.67-4.8,2.71Zm-34.08-.04l-4.81-2.69,.94-1.67,4.81,2.69-.94,1.67Zm43.46-5.27l-.94-1.67,4.8-2.71,.94,1.67-4.8,2.71Zm-52.87,0l-4.81-2.69,.94-1.67,4.81,2.69-.94,1.67Zm-9.4-5.27l-4.81-2.69,.94-1.67,4.81,2.69-.94,1.67Zm71.66-.03l-.94-1.67,4.8-2.71,.94,1.67-4.8,2.71Zm-79.5-7.73l-.18-5.51,1.91-.06,.18,5.51-1.91,.06Zm87.21-.02l-1.91-.06,.18-5.51,1.91,.06-.18,5.51Zm-87.57-10.76l-.18-5.51,1.91-.06,.18,5.51-1.91,.06Zm87.92-.02l-1.91-.06,.18-5.5,1.91,.06-.18,5.5Zm-88.27-10.76l-.18-5.51,1.91-.06,.18,5.51-1.91,.06Zm88.63-.02l-1.91-.06,.18-5.51,1.91,.06-.18,5.51Zm-88.98-10.76l-.18-5.51,1.91-.06,.18,5.51-1.91,.06Zm89.33-.02l-1.91-.06,.18-5.51,1.91,.06-.18,5.51Zm-89.69-10.76l-.18-5.51,1.91-.06,.18,5.51-1.91,.06Zm90.04-.02l-1.91-.06,.18-5.51,1.91,.06-.18,5.51Zm-90.39-10.76l-.18-5.51,1.91-.06,.18,5.51-1.91,.06Zm-.35-10.77l-.18-5.51,1.91-.06,.18,5.51-1.91,.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.51 44.11 43.38 40.25 47.25 40.25 47.25 42.17 45.36 42.17 45.42 44.05 43.51 44.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.23,42.17h-5.25v-1.92h5.25v1.92Zm-9.99,0h-5.25v-1.92h5.25v1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.18,42.17h-5.25v-1.92h5.25v1.92Zm-9.99,0h-5.25v-1.92h5.25v1.92Zm-9.99,0h-5.25v-1.92h5.25v1.92Zm-9.99,0h-5.25v-1.92h5.25v1.92Zm-9.99,0h-5.25v-1.92h5.25v1.92Zm-9.99,0h-5.25v-1.92h5.25v1.92Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.76,65.08h-4.97v-1.92h4.97v1.92Zm-10.71,0h-4.92v-1.92h4.92v1.92Zm-10.66,0h-5.75v-1.92h5.75v1.92Zm-11.49,0h-5.75v-1.92h5.75v1.92Zm-11.49,0h-4.92v-1.92h4.92v1.92Zm-10.66,0h-5.75v-1.92h5.75v1.92Zm-11.49,0h-5.75v-1.92h5.75v1.92Zm-11.49,0h-4.92v-1.92h4.92v1.92Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHetaRound);
export default __webpack_public_path__ + "static/media/heta-round.a3b6136e7da6bd727a4a2ed4e3b9604a.svg";
export { ForwardRef as ReactComponent };